import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchWithResponse } from '@e3dc-react/shell/Types'
import { isNil } from 'lodash'
import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import { WallboxConfigurationDto } from 'src/Libs/wallboxes/dto'
import fromDtoToModel from 'src/Libs/wallboxes/transformers/wallbox-common-settings/from-settings-dto-to-model.transformer'
import fromSettingsModelToDtoTransformer from '../transformers/wallbox-common-settings/from-settings-model-to-dto.transformer'
import { UnexpectedApiResponseError } from 'src/Libs/errors'

export const getWallboxConfiguration = async (
  wallboxStorageId: number | string,
  wallboxIndex: number | string,
  authFetch: AuthFetchWithResponse
): Promise<WallboxConfigurationModel | null> => {
  if (!wallboxStorageId || isNil(wallboxIndex)) throw new Error('Serial number and wallboxIndex must be defined')
  try {
    const response = await authFetch<WallboxConfigurationDto>({
      path: `wallboxes/${wallboxStorageId}/${wallboxIndex}/configuration`,
    })

    if (response.status === StatusCodes.OK) return fromDtoToModel(response.data, wallboxStorageId, wallboxIndex)
    return null
  } catch (error) {
    console.error(`Failed to fetch wallbox configuration for wallbox ${wallboxIndex} of storage ${wallboxStorageId}: ${(error as Error).message}`)
    return null
  }
}

export const updateWallboxConfiguration = async (
  wallboxStorageId: number | string,
  wallboxIndex: number | string,
  model: Partial<WallboxConfigurationModel>,
  authFetch: AuthFetchWithResponse
): Promise<null> => {
  try {
    const payload = fromSettingsModelToDtoTransformer(model)
    const response = await authFetch<void>({
      path: `wallboxes/${wallboxStorageId}/${wallboxIndex}/configuration`,
      method: 'PUT',
      payload,
    })
    if (response.status !== StatusCodes.NO_CONTENT) throw new UnexpectedApiResponseError(response.status)
    return null
  } catch (error) {
    console.error(`Failed to update wallbox configuration for wallbox ${wallboxIndex} of storage ${wallboxStorageId}: ${(error as Error).message}`)
    return null
  }
}
